import { Component, inject, OnInit } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { LOCAL_STORAGE_KEYS } from '../../enums/local-storage.enum';
import { IGeoLocationMapping } from '../../models/cdn.model';
import { IUserProfile } from '../../models/login.model';
import { AppInitializationService } from '../../services/app-initialization/app-initialization.service';
import { StorageService } from '../../services/storage/storage-service';
import { LoaderComponent } from '../../shared/loader/loader.component';
import { ProfileHeaderComponent } from '../../shared/profile-header/profile-header.component';
import { SideMenuComponent } from '../../shared/side-menu/side-menu.component';

@Component({
    selector: 'pims-login-component',
    imports: [MatSidenavModule, RouterOutlet, SideMenuComponent, ProfileHeaderComponent, LoaderComponent],
    templateUrl: './login-component.component.html',
    styleUrl: './login-component.component.scss',
})
export class LoginComponent implements OnInit {
    geoLocationMapping: IGeoLocationMapping[] = [];
    isLoading = false;
    userProfile: IUserProfile = {} as IUserProfile;

    private readonly appInitializationService = inject(AppInitializationService);
    private readonly storageService = inject(StorageService);

    ngOnInit(): void {
        this.geoLocationMapping = this.appInitializationService.getGeoLocationMapping();
        this.userProfile =
            this.storageService.getLocalItem<IUserProfile>(LOCAL_STORAGE_KEYS.USER_PROFILE) ?? ({} as IUserProfile);
        this.isLoading = true;
    }
}
